// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"17bcb54d","366":"e8a4b5f1","487":"b3cc0bfb","649":"7c47867a","737":"1329f3e4"}[chunkId] + ".chunk.js";
};